import { getPublicHeaders } from '@/requests/common/getPublicHeaders';

export { getPublicHeaders as getLibraryHeaders };

export const fetchLibraryData = async <T>(
  url: string,
  transform: (data: unknown) => T | null
): Promise<T | null> => {
  try {
    const res = await fetch(url, { headers: getPublicHeaders() });
    const response = await res.json();
    return transform(response);
  } catch {
    return null;
  }
};
